var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s-uploader-status"},[(_vm.isLoading)?_c('Icon',{attrs:{"name":"loader"}}):_vm._e(),(_vm.text)?_c('Label',{staticClass:"s-uploader-status-text",attrs:{"text":_vm.text}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }